import React from "react";

export function Skeleton({ className = "" }) {
  return <div className={`amden-skeleton ${className}`} />;
}

export function CardSkeleton({ lines = 3 }) {
  return (
    <div className="amden-card p-6">
      <Skeleton className="h-4 w-1/3" />
      <Skeleton className="mt-4 h-8 w-1/2" />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className="mt-3 h-3 w-full" />
      ))}
    </div>
  );
}

export function PageLoading() {
  return (
    <div className="space-y-5">
      <Skeleton className="h-9 w-64" />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="amden-card p-5">
            <Skeleton className="h-3 w-1/2" />
            <Skeleton className="mt-3 h-7 w-1/3" />
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <CardSkeleton lines={4} />
        <CardSkeleton lines={4} />
      </div>
    </div>
  );
}
